import { TButtonTheme } from '@cian/ui-kit/button/types/TButtonTheme';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getNewbuildingId } from '../../selectors/newbuildingHeader';
import { trackPhoneShow } from '../../tracking/newbuilding';
import { ENewbuildingCallPlaceType } from '../../types/newbuildingHeader';
import { NewbuildingCallButtonContainer } from '../NewbuildingCallButton';

interface INewbuildingHeaderCallContainerProps {
  action?: string;
  placeType?: ENewbuildingCallPlaceType;
  theme?: TButtonTheme;
}

export const NewbuildingHeaderCallContainer = ({
  action = 'Open_jk_head_block',
  theme = 'fill_primary',
  placeType = ENewbuildingCallPlaceType.NewbuildingHeaderInSerp,
}: INewbuildingHeaderCallContainerProps) => {
  const newbuildingId = useSelector(getNewbuildingId);

  const onShowPhoneClick = React.useCallback(() => {
    if (newbuildingId) {
      trackPhoneShow({ newbuildingId, action });
    }
  }, [newbuildingId, action]);

  return (
    <NewbuildingCallButtonContainer
      placeType={placeType}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'M' }}
      showPhoneStyles={{ size: 'M', theme }}
    />
  );
};
